import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InspectionService {
  inspection: any;
  page: any;
  attacmentList:any=[];


  editFromDetailsPage=false;

  tabs:any=[
      {"isInfoDetailsView":true, "completed":false, "visited":true},
      {"isAttachmentView":false, "completed":false, "visited":false},
      {"isCaseHistoryView":false, "completed":false, "visited":false},
      // {"addressesPageShow":false, "completed":false, "visited":false},
    ]
 

  

  setInspectionData(caseObj){
      this.inspection=caseObj;
  }
  getInspectionData() {
      return this.inspection;
  }
 
  setAttachmentList(attch){
      this.attacmentList=attch;
  }
  getAttachmentList(){
      return this.attacmentList;
  }

 
  WhatIsNext(index:number,allowAddReport){
      if(!allowAddReport){
          const firstKeysBasicInfo = Object.keys(this.tabs[index-2])
          let firstPageName=firstKeysBasicInfo[0];
          this.tabs[index-2][firstPageName]=false;
          this.tabs[index-2]["completed"]=true;
      }
      const prevKeys = Object.keys(this.tabs[index-1])
      const nextKeys = Object.keys(this.tabs[index])
      
      let prevPageName=prevKeys[0];
      let NextPageName=nextKeys[0];
      
      this.tabs[index-1][prevPageName]=false;
      this.tabs[index-1]["completed"]=true;
      
      this.tabs[index][NextPageName]=true;
      this.tabs[index]["visited"]=true;
      if(index==1){
          this.tabs[index + 1]["visited"]=true;
          this.tabs[index + 2]["visited"]=true;
      }
      else if(index==2){
          this.tabs[index + 1]["visited"]=true;
      }
      else if(index==3){
          this.tabs[0]['isInfoDetailsView']=false;
          this.tabs[0]['completed']=true;
          this.tabs[1]["visited"]=true;
          this.tabs[2]["visited"]=true;
      }
      console.log(this.tabs)
  }
 
  getTabs(){
      return this.tabs;
  }

}
